import React, { Fragment, FunctionComponent, useState } from 'react'
import { navigate } from 'gatsby'

import data from 'mocks/navbar.mock'

import * as S from './styles'
import {
  Navbar as NavbarSection,
  NavItem,
  NavList
} from 'component-library/navbar'
import { NavbarButton } from 'component-library/navbar-button'
import { ConditionallyRender } from 'component-library/conditionally-render'
import { Dropdown, DropdownList } from 'component-library/dropdown'
import { Icon } from 'component-library/icon'

export const Navbar: FunctionComponent = () => {
  const [isFloatContainerOpened, setIsFloatContainerOpened] = useState(false)
  const [isMainDropdownOpened, setIsMainDropdownOpened] = useState(false)

  const handleNavItem = (option: any) => {
    setIsFloatContainerOpened(!isFloatContainerOpened)

    window.open(option.source, '_blank')
  }

  const handleLogoNavigate = () => {
    const searchParams = window.location.search
    navigate(`/${searchParams}`)
  }

  return (
    <NavbarSection
      isFloatContainerOpened={!!isFloatContainerOpened}
      handleLogoNavigate={handleLogoNavigate}
      handleFloatContainerClick={() =>
        setIsFloatContainerOpened(!isFloatContainerOpened)
      }
      navOptionsCompositions={
        <Fragment>
          {data.navOptions.map((item) => (
            <NavItem
              label={item.label}
              handleClick={() => window.open(item.source, '_blank')}
            />
          ))}

          <ConditionallyRender
            minimumBreakpoint="tablet"
            content={
              <Dropdown
                isOpened={!!isMainDropdownOpened}
                staticContentComposition={
                  <NavbarButton
                    label="Entrar"
                    variant="white"
                    handleClick={() =>
                      setIsMainDropdownOpened(!isMainDropdownOpened)
                    }
                    iconElement={
                      <Icon
                        name={
                          isMainDropdownOpened ? 'chevronUp' : 'chevronDown'
                        }
                        color="#DF1D3D"
                      />
                    }
                  />
                }
                openedContentComposition={
                  <DropdownList content={data.dropdownListContent} />
                }
              />
            }
          />
        </Fragment>
      }
      floatContainerComposition={
        <S.Container>
          <NavList
            direction="vertical"
            content={data.navOptions.map((option) => (
              <NavItem
                key={option.label}
                label={option.label}
                handleClick={() => handleNavItem(option)}
              />
            ))}
          />

          <S.ButtonsWrapper>
            {data.floatContainerContent.map((btn) => (
              <NavbarButton
                key={btn.label}
                label={btn.label}
                isFullyAdaptative
                variant={btn?.buttonVariant!}
                handleClick={() => window.open(btn.source, '_blank')}
              />
            ))}
          </S.ButtonsWrapper>
        </S.Container>
      }
    />
  )
}
